import { useVersion } from '@/lib/queries'
import { formatFull } from '@/lib/time'
import { cn } from '@/lib/utils'

/** The commit the server was built from (`/api/version` `commit_short`), so
 *  a screenshot says which build. */
export function BuildStamp({ compact, className }: { compact?: boolean; className?: string }) {
  const v = useVersion()
  const short = v.data?.commit_short || (v.data?.commit ? v.data.commit.slice(0, 7) : '')
  // A binary built without the version ldflags says "dev": name it so.
  const dev = v.data?.commit === 'dev'
  const commit = dev ? (compact ? 'dev' : '개발 빌드') : short || '…'
  const built = v.data?.built_at ? formatFull(v.data.built_at) : ''
  return (
    <span
      title={v.data ? `빌드 ${v.data.commit || short}${built ? ` · ${built}` : ''}` : undefined}
      className={cn('text-micro text-sidebar-muted', className)}
    >
      {!compact && !dev && '빌드 '}
      <span className={dev ? undefined : 'font-mono'}>{compact ? commit.slice(0, 4) : commit}</span>
    </span>
  )
}
